import { ApiProperty } from "@nestjs/swagger";

export class EmployeePhoneNoReq {

    @ApiProperty()
    contactNumber: string
    
}